module.exports = __webpack_public_path__ + "img/pay_card.f06c0f78.png";